import { Button, DatePicker, Flex, Form, Input, TimePicker } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";
import CustomDrawer from "../../../../../components/ui/CustomDrawer";
import {
  useCreateShiftMutation,
  useUpdateShiftMutation,
} from "../../../../../features/organization/contractual/ShiftManagement/shiftManagementApi";
import useError from "../../../../../hooks/useError";
import { toast } from "../../../../../lib/toast";
import CalanderIcon from "../../../survey/templates/_icons/CalanderIcon";
import TimeIcon from "../../../survey/templates/_icons/TimeIcon";
export const parseTime = (value?: string | Date | null) => {
  if (!value) return null;
  const time = dayjs(value);
  console.log(time);
  if (!time.isValid()) return null;
  return dayjs(time.format("HH:mm"), "HH:mm"); // strip date, keep time only
};
const ManageShift = ({
  type,
  open,
  handleClose,
  data,
}: {
  data?: any;
  type?: string;
  open: boolean;
  handleClose: (value?: boolean) => void;
}) => {
  const [form] = Form.useForm();

  const [
    createSlab,
    {
      isLoading: creating,
      isSuccess: created,
      isError: isCreateError,
      error: createError,
    },
  ] = useCreateShiftMutation();
  const [
    updateSlab,
    {
      isLoading: updating,
      isSuccess: updated,
      isError: isUpdateError,
      error: updateError,
    },
  ] = useUpdateShiftMutation();

  const handleSubmit = (values: any) => {
    const { shift_start_time, shift_end_time } = values || {};
    const startTime = dayjs(shift_start_time).format("HH:mm:ss");
    const endTime = dayjs(shift_end_time).format("HH:mm:ss");

    if (type === "ADD") {
      createSlab({
        ...values,
        shift_start_time: startTime,
        shift_end_time: endTime,
      });
    } else {
      updateSlab({
        data: {
          ...values,
          shift_start_time: startTime,
          shift_end_time: endTime,
        },
        id: data?.id,
      });
    }
  };

  // // Disable past dates
  // const disablePastDates = (current: any) => {
  //   return current && current < dayjs().startOf("day");
  // };

  // // Disable "to_date" before "from_date"
  // const disableToDates = (form: any) => (current: any) => {
  //   const fromDate = form.getFieldValue("from_date");
  //   if (!fromDate) return current && current < dayjs().startOf("day");
  //   return current && current < fromDate.startOf("day");
  // };

  // // Disable past times if selected date is today
  // const disablePastTimes = () => {
  //   const fromDate = form.getFieldValue("from_date");
  //   const toDate = form.getFieldValue("to_date");
  //   const now = dayjs();

  //   const isToday =
  //     (fromDate && dayjs(fromDate).isSame(now, "day")) ||
  //     (toDate && dayjs(toDate).isSame(now, "day"));

  //   if (isToday) {
  //     const hour = now.hour();
  //     const minute = now.minute();
  //     return {
  //       disabledHours: () => Array.from({ length: hour }, (_, i) => i),
  //       disabledMinutes: (selectedHour: any) =>
  //         selectedHour === hour
  //           ? Array.from({ length: minute }, (_, i) => i)
  //           : [],
  //     };
  //   }
  //   // For future dates → all times enabled
  //   return {};
  // };

  // Disable past dates
  const disablePastDates = (current: any) => {
    return current && current < dayjs().startOf("day");
  };

  // Disable "to_date" before "from_date"
  const disableToDates = (form: any) => (current: any) => {
    const fromDate = form.getFieldValue("from_date");
    if (!fromDate) return current && current < dayjs().startOf("day");
    return current && current < fromDate.startOf("day");
  };

  // Disable past times if selected date is today
  const disablePastTimes = () => {
    const fromDate = form.getFieldValue("from_date");
    const toDate = form.getFieldValue("to_date");
    const now = dayjs();

    const isToday =
      (fromDate && dayjs(fromDate).isSame(now, "day")) ||
      (toDate && dayjs(toDate).isSame(now, "day"));

    if (isToday) {
      const hour = now.hour();
      const minute = now.minute();
      return {
        disabledHours: () => Array.from({ length: hour }, (_, i) => i),
        disabledMinutes: (selectedHour: any) =>
          selectedHour === hour
            ? Array.from({ length: minute }, (_, i) => i)
            : [],
      };
    }
    return {}; // all times enabled for future dates
  };

  // Handle from_date change → auto set shift_start_time if today
  const handleFromDateChange = (date: any) => {
    const now = dayjs();

    if (date && dayjs(date).isSame(now, "day")) {
      // Set current time
      form.setFieldsValue({
        shift_start_time: now,
      });
    } else {
      // Clear shift_start_time if not today
      form.setFieldsValue({
        shift_start_time: null,
      });
    }
  };

  // ------ Effects ------
  useEffect(() => {
    if (data) {
      const startTime = data?.shift_start_time
        ? dayjs(data.shift_start_time, "HH:mm:ss")
        : null;
      const endTime = data?.shift_end_time
        ? dayjs(data.shift_end_time, "HH:mm:ss")
        : null;

      form.setFieldsValue({
        ...data,
        shift_start_time: startTime,
        shift_end_time: endTime,
        from_date: dayjs(data?.from_date),
        to_date: dayjs(data?.to_date),
      });
    }
  }, [data, form]);

  useEffect(() => {
    if (created) {
      toast("success", "Shift created successfully.");
      handleClose();
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [created]);

  useEffect(() => {
    if (updated) {
      toast("success", "Shift updated successfully.");
      handleClose();
      form.resetFields();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updated]);

  // ------ Errors ------
  useError(isCreateError, createError, "Shift create failed.");
  useError(isUpdateError, updateError, "Shift update failed.");

  return (
    <CustomDrawer
      width={460}
      open={open}
      onClose={handleClose}
      title={type === "ADD" ? "Add New Shift" : "Edit Shift"}
    >
      <Form
        form={form}
        size="large"
        layout="vertical"
        requiredMark="optional"
        className="custom-form"
        onFinish={handleSubmit}
      >
        <Form.Item
          name="shift_name"
          label="Shift Name"
          className="mb-4"
          rules={[{ required: true, message: "Please enter shift name" }]}
        >
          <Input placeholder="Enter shift name" />
        </Form.Item>

        {/* Date Range */}
        <div className="grid grid-cols-2 gap-4 items-end">
          <Form.Item
            name="from_date"
            label="Date Range"
            className="mb-4"
            rules={[{ required: true, message: "Please select from date" }]}
          >
            <DatePicker
              className="w-full"
              format={"DD/MM/YYYY"}
              placeholder={"dd/mm/yyyy"}
              suffixIcon={<CalanderIcon />}
              disabledDate={disablePastDates}
              onChange={handleFromDateChange}
            />
          </Form.Item>
          <Form.Item
            name="to_date"
            className="mb-4"
            rules={[{ required: true, message: "Please select to date" }]}
          >
            <DatePicker
              className="w-full"
              format={"DD/MM/YYYY"}
              placeholder={"dd/mm/yyyy"}
              suffixIcon={<CalanderIcon />}
              disabledDate={disableToDates(form)}
            />
          </Form.Item>
        </div>

        {/* Time Range */}
        <div className="grid grid-cols-2 gap-4 items-end">
          <Form.Item
            name="shift_start_time"
            label="Time"
            className="mb-4"
            rules={[{ required: true, message: "Please select start time" }]}
          >
            <TimePicker
              use12Hours
              format="hh:mm A"
              className="w-full"
              suffixIcon={<TimeIcon />}
              placeholder={"00:00"}
              disabledTime={disablePastTimes}
            />
          </Form.Item>
          <Form.Item
            name="shift_end_time"
            className="mb-4"
            rules={[{ required: true, message: "Please select end time" }]}
          >
            <TimePicker
              use12Hours
              format="hh:mm A"
              className="w-full"
              suffixIcon={<TimeIcon />}
              placeholder={"00:00"}
              // disabledTime={disablePastTimes}
            />
          </Form.Item>
        </div>

        {/* Number of Seats */}
        <Form.Item
          name="number_of_seat"
          label="Number of Seat"
          className="mb-4"
          rules={[
            { required: true, message: "Please enter number of seats" },
            {
              validator: (_, value) => {
                if (value === "" || value === null || value === undefined) {
                  // Let the "required" rule handle this case
                  return Promise.resolve();
                }

                const num = Number(value);

                if (!Number.isInteger(num)) {
                  return Promise.reject("Number of seat cannot be decimal");
                }
                if (num < 0) {
                  return Promise.reject("Number of seat cannot be negative");
                }
                if (num === 0) {
                  return Promise.reject("Number of seat cannot be Zero(0)");
                }

                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="Number of seat" type="number" />
        </Form.Item>

        <Flex align="center" gap={16} className="mt-6">
          <Button
            size="middle"
            htmlType="button"
            className="min-w-[120px] h-10"
            onClick={() => {
              handleClose();
              form.resetFields();
            }}
          >
            Cancel
          </Button>
          <Button
            size="middle"
            htmlType="submit"
            type="primary"
            color="primary"
            className="min-w-[120px] h-10"
            loading={creating || updating}
          >
            {type === "ADD" ? "Add New Shift" : "Update"}
          </Button>
        </Flex>
      </Form>
    </CustomDrawer>
  );
};

export default ManageShift;
